import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { bemClassBuilder } from '@vista-digital/bem-class-builder';
import { observer } from 'mobx-react';
import { useRef, useState } from 'react';
import { useFilmContext } from '../../../context/film/hooks/use-film-context';
import { useI18n } from '../../../context/occ/hooks/use-i18n';
import { useOccSubcomponents } from '../../../context/occ/hooks/use-occ-subcomponents';
import { useFilmTrailerUrl } from '../../../hooks/use-film-trailer-url';
import { Icon } from '../../../subcomponents/icon';
import { withComponentWrapper } from '../../../utils/with-component-wrapper';
import { FilmTrailer } from '../trailer/film-trailer';
import { defaultFilmTrailerButtonProps, filmTrailerButtonPropsValidator } from './types/props';
const b = bemClassBuilder('v-film-trailer-button');
export const FilmTrailerButton = observer(props => {
    const { FilmTrailerModal } = useOccSubcomponents();
    const i18n = useI18n();
    const { displayText, assets, config, events } = props;
    const { film } = useFilmContext();
    const { playTrailerButtonLabel, failedToLoadTrailerTitle, failedToLoadTrailerRetryButtonLabel } = displayText;
    const { playTrailerButtonIconName, failedToLoadTrailerIconName } = assets;
    const [showModal, setShowModal] = useState(false);
    const filmTrailerRef = useRef(null);
    const trailerUrl = useFilmTrailerUrl(film);
    if (!film || !trailerUrl)
        return null;
    const handlePlayButtonClicked = async () => {
        var _a;
        (_a = events.onPlayTrailerButtonClicked) === null || _a === void 0 ? void 0 : _a.call(events, film);
        setShowModal(true);
    };
    const onCloseModalHandler = () => setShowModal(false);
    return (_jsxs(_Fragment, { children: [_jsx("button", Object.assign({ className: b.block(undefined), onClick: handlePlayButtonClicked }, { children: _jsxs("span", Object.assign({ className: b.element('wrapper') }, { children: [playTrailerButtonIconName && (_jsx(Icon, { className: b.element('icon'), name: playTrailerButtonIconName })), playTrailerButtonLabel && _jsx("span", Object.assign({ className: b.element('label') }, { children: playTrailerButtonLabel }))] })) })), _jsx(FilmTrailerModal, Object.assign({ className: b.element('modal'), show: showModal, onClose: onCloseModalHandler, heading: i18n.translatable(film.title) }, { children: _jsx(FilmTrailer, { displayText: {
                        failedToLoadTrailerTitle,
                        failedToLoadTrailerRetryButtonLabel
                    }, assets: {
                        failedToLoadTrailerIconName
                    }, events: events, config: config, ref: filmTrailerRef }) }))] }));
});
FilmTrailerButton.displayName = 'FilmTrailerButton';
/**
 * The **Film Trailer Button** component renders a button that plays the trailer for a film.
 */
export const FilmTrailerButtonComponent = withComponentWrapper(FilmTrailerButton, defaultFilmTrailerButtonProps, filmTrailerButtonPropsValidator);
